import React from 'react'
import clsx from 'clsx'
import styles from './label.module.scss'
import PropTypes from 'prop-types'

const Label = ({ className, severity, component, ...rest }) => {
  const Component = component || 'span'
  const severityValue = severity || 'info'

  return (
    <Component
      {...rest}
      className={clsx(className, styles['root'], {
        [styles[`severity-${severityValue}`]]: severityValue,
      })}
    />
  )
}

Label.propTypes = {
  className: PropTypes.string,
  severity: PropTypes.string,
  component: PropTypes.string,
}

export default Label
